var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"division",attrs:{"data-title":_vm.tooltip,"data-pic":_vm.icon}},[(_vm.active)?_c('div',{staticClass:"component_content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }